import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface PINProps {
  color?: string;
  style?: React.CSSProperties;
}

export const PIN = ({ color = RoutalPalette.primary40, style = {}, ...props }: PINProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 18 20" style={{ width: `18px`, height: `20px`, ...style }}>
      <g>
        <path
          fill={color}
          d="m8.99,19.4c-2,0-8.29-3.6-8.29-11.96v-3.99c0-.47.32-.88.77-1l7.21-1.87c.19-.05.39-.05.58,0l7.27,1.88c.46.12.78.53.78,1v3.96c0,8.38-6.31,11.98-8.32,11.98Zm.02-17.85L1.72,3.42l-.03,4.02c0,8.1,6.01,10.96,7.29,10.96s7.32-2.86,7.32-10.98v-3.96l-7.3-1.91Z"
        />
        <path
          fill={color}
          d="m11.64,8.43c0-1.45-1.18-2.64-2.64-2.64s-2.64,1.18-2.64,2.64c0,.88.45,1.66,1.16,2.15l-.32,2.8c0,.51.41.92.92.92h1.77c.51,0,.92-.41.91-.97l-.31-2.74c.69-.48,1.14-1.26,1.14-2.16Zm-3.16,2.58l.12-1c-.11-.03-.21-.06-.31-.11-.57-.28-.92-.84-.92-1.47,0-.9.73-1.64,1.64-1.64s1.64.73,1.64,1.64c0,.76-.52,1.39-1.22,1.58l.12,1.01s0,0,0,0l.26,2.28h-1.58"
        />
      </g>
    </SvgIcon>
  );
};
